export const bomKeys = {
  all: ['boms'] as const,
  many: (queryProps?: Record<string, unknown>, type = 'list') =>
    [...bomKeys.all, type, ...[queryProps]].filter(Boolean),
  one: (id: number) => [...bomKeys.all, 'detail', id] as const,
};
